var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPublic
    ? _c(
        "transition-group",
        { attrs: { id: "calendars-list", name: "list", tag: "ul" } },
        [
          _c("AppNavigationSpacer", { key: _vm.spacerKey }),
          _vm._v(" "),
          _vm.loadingCalendars
            ? _c("CalendarListItemLoadingPlaceholder", {
                key: _vm.loadingKeyCalendars
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.allCalendars, function(calendar) {
            return _c("CalendarListItem", {
              key: calendar.id,
              attrs: { calendar: calendar }
            })
          }),
          _vm._v(" "),
          !_vm.loadingCalendars
            ? _c("CalendarListNew", {
                key: _vm.newCalendarKey,
                attrs: { disabled: _vm.loadingCalendars }
              })
            : _vm._e()
        ],
        2
      )
    : _c(
        "transition-group",
        { attrs: { id: "calendars-list", name: "list", tag: "ul" } },
        [
          _vm.loadingCalendars
            ? _c("CalendarListItemLoadingPlaceholder", {
                key: _vm.loadingKeyCalendars
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.subscriptions, function(calendar) {
            return _c("PublicCalendarListItem", {
              key: calendar.id,
              attrs: { calendar: calendar }
            })
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }